module.exports = {"350603100":"蓝田镇","350603101":"步文镇","350603102":"朝阳镇","350603103":"郭坑镇","350603500":"蓝田开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350603.json
// module id = 1113
// module chunks = 0